class ReferralProgram {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}`;
    this.apiClient = apiClient;

  }

  async createCashRewardReferralCampaign(campaign) {

    const path = this.basePath + '/referral-campaigns/cash';

    return this.apiClient.post(path, {}, {}, campaign);

  }

  async createMetricsRewardReferralCampaign(campaign) {

    const path = this.basePath + '/referral-campaigns/metrics';

    return this.apiClient.post(path, {}, {}, campaign);

  }

  async createCoinsRewardReferralCampaign(campaign) {

    const path = this.basePath + '/referral-campaigns/coins';

    return this.apiClient.post(path, {}, {}, campaign);

  }

  async createOtherRewardReferralCampaign(campaign) {

    const path = this.basePath + '/referral-campaigns/other';

    return this.apiClient.post(path, {}, {}, campaign);

  }

  async getReferralCampaignById(referralCampaignId, projection) {

    const path = this.basePath + '/referral-campaigns/:referralCampaignId';

    return this.apiClient.get(path, { referralCampaignId }, {});

  }

  async updateCashRewardReferralCampaignById(referralCampaignId, campaign) {

    const path = this.basePath + '/referral-campaigns/:referralCampaignId/cash';

    return this.apiClient.put(path, { referralCampaignId }, {}, campaign);

  }

  async updateMetricsRewardReferralCampaignById(referralCampaignId, campaign) {

    const path = this.basePath + '/referral-campaigns/:referralCampaignId/metrics';

    return this.apiClient.put(path, { referralCampaignId }, {}, campaign);

  }

  async updateCoinsRewardReferralCampaignById(referralCampaignId, campaign) {

    const path = this.basePath + '/referral-campaigns/:referralCampaignId/coins';

    return this.apiClient.put(path, { referralCampaignId }, {}, campaign);

  }

  async updateOtherRewardReferralCampaignById(referralCampaignId, campaign) {

    const path = this.basePath + '/referral-campaigns/:referralCampaignId/other';

    return this.apiClient.put(path, { referralCampaignId }, {}, campaign);

  }

  async deleteReferralCampaignById(referralCampaignId) {

    const path = this.basePath + '/referral-campaigns/:referralCampaignId';

    return this.apiClient.delete(path, { referralCampaignId }, {});

  }

  async getReferralProgramSettings() {

    const path = this.basePath + '/referral-program-settings';

    return this.apiClient.get(path, {}, {});

  }

  async updateReferralProgramSettings(referralProgramSettings) {

    const path = this.basePath + '/referral-program-settings';

    return this.apiClient.put(path, {}, {}, referralProgramSettings);

  }

}

export default ReferralProgram;